import { render, staticRenderFns } from "./SpotlightDisplay.vue?vue&type=template&id=078313c0"
import script from "./SpotlightDisplay.vue?vue&type=script&lang=js"
export * from "./SpotlightDisplay.vue?vue&type=script&lang=js"
import style0 from "./SpotlightDisplay.vue?vue&type=style&index=0&id=078313c0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports